const RESOURCE_PREFIX = window.appSetup.links.static.resourcePrefix;
const RESOURCE_PATH = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_RESOURCE_PATH || 'resources/desktop_app/'
  : '';

// eslint-disable-next-line import/prefer-default-export
export const getStaticPath = (filePath = '') => {
  const prefix = `${RESOURCE_PREFIX}${RESOURCE_PATH}`;

  if (prefix.endsWith('/') && filePath.startsWith('/')) {
    return `${prefix}${filePath.substring(1)}`;
  }

  if (!prefix.endsWith('/') && !filePath.startsWith('/')) {
    return `${prefix}/${filePath}`;
  }

  return `${prefix}${filePath}`;
};
